import { defineMessages } from 'react-intl';

const messages = defineMessages({
  dimensions: {
    description: 'Dimensions value e.g. 1l x 2w x 3h (unit)',
    defaultMessage: '{length}l x {width}w x {height}h ({unit})',
    id: '8RwVua',
  },
  centimetersAbbreviation: {
    defaultMessage: 'cm',
    id: 'CLTVgW',
    description: 'An abbreviation for the "centimeters" unit of dimensions LxWxH (unit)',
  },
  inchesAbbreviation: {
    defaultMessage: 'in',
    id: 'k8ziaC',
    description: 'An abbreviation for the "inches" unit of dimensions LxWxH (unit)',
  },
});

export default messages;
